import { render } from "./BookingExtrasModalCase1.vue?vue&type=template&id=01adb0c6"
import script from "./BookingExtrasModalCase1.vue?vue&type=script&lang=js"
export * from "./BookingExtrasModalCase1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingExtrasModalCase1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01adb0c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01adb0c6', __exports__)) {
    api.reload('01adb0c6', __exports__)
  }
  
  module.hot.accept("./BookingExtrasModalCase1.vue?vue&type=template&id=01adb0c6", () => {
    api.rerender('01adb0c6', render)
  })

}


export default __exports__